import { NgModule, APP_INITIALIZER } from '@angular/core';

import { FeatureTogglesFacade, FeatureToggleType } from '@cigna/features';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
  Feature,
} from '@cigna/chcp/shared/environment-util';

import zipObject from 'lodash/zipObject';
import { FeatureFlagService } from './feature-flag.service';
import { filter } from 'rxjs/operators';

export const configFeaturesFactory =
  (config: EnvironmentConfig, features: FeatureTogglesFacade) => () => {
    features.updateFeatureToggles(config.features, FeatureToggleType.RELEASE);
  };

/*
 https://storybook-nx.apps.gp-1-nonprod.openshift.cignacloud.com/iframe.html?id=docs-knowledge-base--feature-toggles&viewMode=story#permission-toggles
 - this is not a list of all feature toggles, only select ones that are also set at user level through jwt to enable user based feature rollout
 - per docs above any feature toggle included here will be disabled by default unless it explicity comes in user jwt, as permission toggle flag supersedes environment level flag

*/
export const permissionToggles: Feature[] = [
  'patientOldView',
  'messageCenterClaimStatus',
  'messageCenterDashboard',
  'chat',
  'medicare',
];

// todo: deprecated delete in future if we stick with canActivate approach
export const opsFeaturesFactory =
  (
    authFacade: AuthFacade,
    features: FeatureTogglesFacade,
    service: FeatureFlagService,
  ) =>
  () => {
    authFacade.isUserAuthenticated$
      .pipe(filter((auth) => auth))
      .subscribe(() => {
        // call feature flag api to get runtime flags
        service.getOpsToggles().subscribe((flags) => {
          features.updateFeatureToggles(flags, FeatureToggleType.OPS);
        });
      });
  };

export const permissionFeaturesFactory =
  (authFacade: AuthFacade, features: FeatureTogglesFacade) => () => {
    features.updateFeatureToggles(
      zipObject(permissionToggles, Array(permissionToggles.length).fill(false)),
      FeatureToggleType.PERMISSION,
    );
    authFacade.permissionToggles$.subscribe((permToggles) => {
      // jwt may come back with no permissionToggles
      if (permToggles) {
        features.updateFeatureToggles(
          zipObject(permToggles, Array(permToggles.length).fill(true)),
          FeatureToggleType.PERMISSION,
        );
      }
    });
  };

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: permissionFeaturesFactory,
      deps: [AuthFacade, FeatureTogglesFacade],
    },
    // disabling in favor of placing canActivate: [FeatureToggleLoader] on layout secure route
    // leaving here temporarily in case we decide to flip back
    // {
    //   provide: APP_INITIALIZER,
    //   multi: true,
    //   useFactory: opsFeaturesFactory,
    //   deps: [AuthFacade, FeatureTogglesFacade, FeatureFlagService],
    // },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: configFeaturesFactory,
      deps: [ENVIRONMENT_CONFIG, FeatureTogglesFacade],
    },
  ],
})
export class ChcpSharedFeaturesUtilModule {}
